export type GetDataKindResponse = {
  dataKindList: GetDataKind[];
  fileLayoutList: GetFileLayout[];
};

export type GetDataKind = {
  delFlg: string;
  dtKindId: string;
  mltcstDsbldFlg: string;
  dtKindNameLclLang: string;
  dtKindNameEng: string;
  dtKindNameWtngChngLclLang: string;
  dtKindNameWtngChngEng: string;
  updateDateTime: string;
  deployedInEdhFlg: string;
};
export type GetFileLayout = {
  delFlg: string;
  dtKindId: string;
  dtKindNameLclLang: string;
  dtKindNameEng: string;
  fileId: string;
  ownCpntId: string;
  bsFileFlg: string;
  frkRsnTypName: string;
  frkRsnTypCd: string;
  updateDateTime: string;
};
